//#region imports
import React, { useEffect, useState } from 'react'

// bootstrap
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'

// validator
import validator from 'validator'

// tremor
import { Flex } from '@tremor/react'

// redux
import { useSelector, useDispatch } from 'react-redux';
import { getEmployeeTasks, resetEditPasswordForm, selectCheckUserStatus, resetUpdateEmployeeStatus, selectEditPasswordError, selectEditPasswordStatus, updateOldEmployeeProfile, updateEmployee, selectUpdateEmployeeStatus } from '_redux/slices/timeline/employees';
import { selectUsedTheme } from '_redux/slices/timeline/theme';

// styling
import { Colors, Spacing } from '_styles'

// components
import { CustomSpinner } from '_atoms'
//#endregion


const EditPasswordForm = (props) => {

    //#region redux
    const dispatch = useDispatch();

    const editPasswordError = useSelector(selectEditPasswordError);    // Error message if password update fails
    const checkUserStatus = useSelector(selectCheckUserStatus);        // Status of the user verification check
    const passwordStatus = useSelector(selectEditPasswordStatus);          // Current status of users password , this handle old employees without firebase creation
    const updateEmployeeStatus = useSelector(selectUpdateEmployeeStatus)
    const usedTheme = useSelector(selectUsedTheme);
    //#endregion

    //#region local state
    const [password, setPassword] = useState('');                      // input field for new password
    const [passwordErrors, setPasswordErrors] = useState({});          // local validation error
    //#endregion


    //#region functions

    // Validates the entered password 
    const validateEmployee = (validatedPassword) => {
        let errors = {};

        // Check if password is provided
        if (validatedPassword === undefined || validatedPassword.length === 0) {
            errors.password = 'Password is required';
        } else {
            // Validate password strength -> at least one uppercase, one symbol, one number, and 8 chars min.
            let isValidPassword = validator.isStrongPassword(validatedPassword);
            if (!isValidPassword) {
                errors.password = 'Passwords must be min 8 chars and made of at least one capital, one symbol, and one number';
            }
        }

        return errors;
    };

    // Handles the submission for updating the password
    const submitPassword = () => {

        let errors = validateEmployee(password); // validate the password
        let invalid = false;

        // Check password isn't empty
        if (password.length === 0) {
            errors.password = "Password cannot be empty";
            invalid = true;
        }

        // Check for password validity
        const isValidPassword = !Object.keys(errors).includes('password');

        if (!isValidPassword || invalid) {
            setPasswordErrors(errors);  // show errors if invalid 
            return;
        } else if (!props?.employee.userId) {
            setPasswordErrors({});
            dispatch(updateOldEmployeeProfile({
                email: props?.employee.email,
                password: password
            }));
        } else {
            setPasswordErrors({});     // clear errors if valid
            const payload = {
                userId: props?.employee.userId,
                body: {
                    password
                }
            }
            dispatch(updateEmployee(payload));
        }
    };

    // Closes the modal and resets password form state
    const handleCloseModal = () => {
        dispatch(resetEditPasswordForm())
        props.closeModal()
    }
    //#endregion


    //#region useEffect
    // Reset the password edit form
    useEffect(() => {
        dispatch(resetEditPasswordForm());
        dispatch(resetUpdateEmployeeStatus());

    }, []);

    // Handle when password edit status changes
    useEffect(() => {
        if (passwordStatus === "succeeded") {
            // Create a copy of the employee and update the password field
            let tempObject = { ...props?.employee };
            tempObject.password = password;

            props?.setEmployeeInformation((prevState) => ({
                ...prevState,
                password: password,
            }));
            handleCloseModal();

        };
    }, [passwordStatus, checkUserStatus]);

    // Set error if password update fails
    useEffect(() => {
        if (editPasswordError !== null || editPasswordError !== undefined)
            setPasswordErrors({
                password: editPasswordError,
            });
    }, [editPasswordError]);

    useEffect(() => {
        if (updateEmployeeStatus === "succeeded") {
            dispatch(resetUpdateEmployeeStatus());
            props.closeModal()
        }
    }, [updateEmployeeStatus])

    // Set password and fetch tasks if exists
    useEffect(() => {
        if (props?.employee != undefined) {
            if (props?.employee.password != undefined && props?.employee.password != '') {
                setPassword(props?.employee.password);
            }
            // get employee tasks
            dispatch(getEmployeeTasks(props?.employee.employeeId));
        }
    }, [props?.employee]);
    //#endregion

    return (
        <>
            {/* dark mode styling */}
            <style>
                {`
                    .form-input::placeholder {
                    color: ${usedTheme.TEXT_COLOR} !important;
                    opacity: 1;
                    }
                `}
            </style>

            <div>
                <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE }}>{'Enter New Password'}</Form.Label>
                <Form.Control
                    className="form-input"
                    onChange={(e) => setPassword(e.target.value)}
                    // type="password"
                    type="text"
                    placeholder="New Password"
                    style={{ backgroundColor: usedTheme.BACKGROUND_COLOR, borderColor: usedTheme.BORDER_COLOR, color: usedTheme.TEXT_COLOR }}
                />
                {passwordErrors.password && (
                    <p className="text-danger">{passwordErrors.password}</p>
                )}
                {/* buttons */}
                <div style={{ marginTop: Spacing.SCALE_22 }}>
                    <Flex>
                        <Button variant="danger" onClick={handleCloseModal} disabled={passwordStatus === 'loading' || updateEmployeeStatus === "loading"} style={{ marginLeft: Spacing.SCALE_8 }}>
                            {'Cancel'}
                        </Button>
                        <Button
                            onClick={submitPassword}
                            variant={'primary'} style={{ marginLeft: Spacing.SCALE_8 }}>{passwordStatus == 'loading' || updateEmployeeStatus === "loading" ? <CustomSpinner /> : 'Confirm'}</Button>
                    </Flex>
                </div>
            </div >
        </>
    );
}

export default EditPasswordForm;